import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Image from '@material-ui/icons/Image'
import moment from "moment";
import Select from "react-select";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";

export default class TicketsFinancialsSignatures extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Financials_Signatures._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.filterDate = moment();
		this.state.user = null;
		this.state.users = [];
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getUsers();
	}

	getUsers = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		model.limit = 100;
		this.data = await model.submit(null, 'GET_FIELD_ENGINEERS');
		this.setState({
			users: this.data.items
		});
	}

	getOverrides = async () => {
		await this.fetchData(this.state)
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterDate = this.state.filterDate;
		this.state.filter.user = this.state.user?.value;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	handleDaySelect = async (event) => {
		let date = null;
		let currentDate = this.state.filterDate;
		switch (event.currentTarget.id) {
			case 'sub':
				date = moment(currentDate).subtract(1, 'day').format()
				break;
			case 'add':
				date = moment(currentDate).add(1, 'day').format()
				this.setState({shouldShowWarning: false})
				break;
			case 'today':
				date = moment().format();
				break;
		}
		await this.setState({filterDate: date});
		await this.getOverrides(false);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "KT3 Ticket",
				id: 'ticket',
				/** @param {Tickets_Financials_Signatures_Object} obj */
				accessor: obj => obj.ticket,
				Cell: (props) => {
					return (
						<span>
							<Link to={`/tickets/${props.original.ticket}`}>
								{props.original.ticket}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Freshdesk Ticket",
				id: "fresh_ticket",
				/** @param {Tickets_Financials_Signatures_Object} props.original */
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
			},
			{
				Header: "Engineer Name",
				id: "engineer",
				/** @param {Tickets_Financials_Signatures_Object} obj */
				accessor: obj => obj.engineer
			},
			{
				Header: "Approving Manager",
				id: "manager_override_approver",
				/** @param {Tickets_Financials_Signatures_Object} obj */
				accessor: obj => obj.manager_override_approver
			},
			{
				Header: "Date Signed",
				id: "date",
				/** @param {Tickets_Financials_Signatures_Object} obj */
				accessor: obj => obj.date ? moment(obj.date).local().format('MM/DD/YYYY h:mm A') : ''
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				/** @param {Tickets_Financials_Signatures_Object} obj */
				accessor: obj => obj.signature,
				Cell: props => {
					return (
						<span>
							<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
								this.setState({sigModal: true, sig: props.original.signature})
							}}>
								<Image fontSize={'small'}/></Button>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<div className={'row'}>
					<div className={"col-4"} style={{display: "flex", fontSize: 20, justifyContent: "center"}}>
						<div className={"row rbc-toolbar"}>
							<div className={"rbc-toolbar-label"} style={{marginTop: 10}}>
								<label>
									{moment(this.state.filterDate).format('dddd MMM D')}
								</label>
							</div>
							<div className={"rbc-btn-group"}>
								<Button id={'sub'} onClick={this.handleDaySelect}><LeftArrowIcon/></Button>
								<Button id={'today'} onClick={this.handleDaySelect}>Today</Button>
								<Button id={'add'} onClick={this.handleDaySelect}><RightArrowIcon/></Button>
							</div>
						</div>
					</div>
					<div className={'col-2'}>
						<Select
							key={this.state.users}
							placeholder={"Engineer Select"}
							isMulti={false}
							isClearable
							value={this.state.user}
							onChange={async (value) => {
								this.state.user = value
								this.setState({user: value})
								await this.getOverrides()
							}}
							options={this.state.users.map(user => {
								return (
									{value: user.pkey, label: user.name_first + ' ' + user.name_last})
							})}
							styles={this.styles}
						/>
					</div>
					<div className={'col-6'}>
						<div className='d-flex' style={{marginRight: '15px'}}>
							{this.renderHeaderRight("Tickets_Financials_Signatures", columns)}
						</div>
					</div>
				</div>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal
						isOpen={this.state.sigModal}
						toggle={() => {
							this.setState({sigModal: false, sig: null})
						}}
						size={'lg'}
						backdrop={true}
					>
						<ModalHeader toggle={() => {
							this.setState({sigModal: false, sig: null})
						}}>
							Signature Recorded
						</ModalHeader>
						<ModalBody style={{display: 'grid', justifyContent: 'center'}}>
							<b style={{textAlign: 'center'}}>You are approving that A MANAGER authorized this change. If this was NOT approved, you are signing authorization for Karls Technology to bill you this amount.</b>
							<img width={'90%'} height={'50%'} src={this.state.sig} alt={'Signature'}/>
						</ModalBody>
					</Modal>
				</CardContent>
			</Card>
		)
	}

	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: '1px 6px'
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		})
	};


	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: '30px'
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: 'visible',
				padding: '1px 8px'
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute", //(state.hasValue && state.selectProps.value.label) &&
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: '1rem',
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'rgba(0, 0, 0, 0.54)',
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				//transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'matrix(0.75, 0, 0, 0.75, 14, -6)',
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'white',
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && '0 8px',
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2
			})
		}
	};
}

